<template>
    <div v-if="flags.length" class="flags text--white">
        <svg><use xlink:href="#alert" /></svg>
        <div>
            <p v-for="(flag, index) in flags" :key="index" class="small semi">{{ flag }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        flags: {
            type: Array,
            default: () => []
        },
    },
};
</script>

<style lang="scss" scoped>
    .flags {
        .small {
            padding-bottom: 10px;
        }
    }
</style>
